"use strict";

const BaseModuleSettings = require("./baseModuleSettings");

const IndcomModuleSettings = function () {
  const tool = "indcom";
  const key = "indcom-module";
  const formKey = "indcom-module-settings";
  const option = "Industrial/Commercial Module";
  const iconClass = "indcom";
  const userVariableValidatorClassIndcom = "validate-indcom-maintenance-notice-variables";
  const moduleProps = { userVariableValidatorClassIndcom };

  const initValidatorFunction = (props) => {
    UserVariableValidator.init(
      Object.keys(props?.indcom?.maintenanceNoticeUserTemplate || {}),
      `.${userVariableValidatorClassIndcom}`,
    );
  };

  const base = new BaseModuleSettings(
    tool,
    key,
    formKey,
    option,
    iconClass,
    moduleProps,
    initValidatorFunction,
  );

  return {
    ...base,
  };
};

module.exports = IndcomModuleSettings();

const UserVariableValidator = require("../../misc/userVariableValidator");
